import * as React from "react";
const SvgIcTriangleDown = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M4.00221 8L19.9992 8L12.0002 18L4.00221 8Z" fill="currentColor" /></svg>;
export default SvgIcTriangleDown;